import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "@data-phone/react-resource-server-auth";

export const fetchIntegrationsData = createAsyncThunk<
  string[],        
  void,            
  { rejectValue: string } 
>(
  "integrations/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_BASE_URL}/integrations/integrations`
      );
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch integrations", error);
      return rejectWithValue(error?.message || "Failed to fetch integrations");
    }
  }
);
